import { AxiosResponse } from "axios";
import { apiInstance } from "@/store/configureStore";

export const getMarketplaceDonateRequest = async () => {
  const response: AxiosResponse = await apiInstance.get("/marketplace/donate");

  return response.data;
};
